import styled from 'styled-components';

import BorderBottomSpan from '../../BorderBottomSpan';

const LoginBorderBottomSpan = styled(BorderBottomSpan)`
  &::after {
    border-width: 4px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export default LoginBorderBottomSpan;
